const jbValidateBidders = (allBiddersData: any) => {
  let isValid = true;

  const emailIdx = new Map<string, number>();
  const mobileIdx = new Map<string, number>();
  const panIdx = new Map<string, number>();

  allBiddersData.forEach((b: any, idx: number) => {
    b.errors = {};

    // Normalize and validate email
    const email = b.email?.toString().trim();
    if (!email || email === "") {
      b.errors.email = "Bidder Email is required";
      isValid = false;
    } else if (emailIdx.has(email)) {
      b.errors.email = "Email must be unique";
      allBiddersData[emailIdx.get(email)!].errors!.email =
        "Email must be unique";
      isValid = false;
    } else {
      emailIdx.set(email, idx);
    }

    // Normalize and validate mobile number
    const mobile = b.mobile_number?.toString().trim();
    if (!mobile || mobile === "") {
      b.errors.mobile_number = "Bidder Mobile number is required";
      isValid = false;
    } else if (mobileIdx.has(mobile)) {
      b.errors.mobile_number = "Mobile number must be unique";
      allBiddersData[mobileIdx.get(mobile)!].errors!.mobile_number =
        "Mobile number must be unique";
      isValid = false;
    } else {
      mobileIdx.set(mobile, idx);
    }

    // Normalize and validate PAN
    const pan = b.pan?.toString().trim().toUpperCase();
    if (!pan || pan === "") {
      b.errors.pan = "Bidder PAN is required";
      isValid = false;
    } else if (panIdx.has(pan)) {
      b.errors.pan = "PAN must be unique";
      allBiddersData[panIdx.get(pan)!].errors!.pan = "PAN must be unique";
      isValid = false;
    } else {
      panIdx.set(pan, idx);
    }
  });
  let allErrors = null;
  if (!isValid) {
    allErrors = allBiddersData.map((b: any, idx: number) => ({
      index: idx,
      ...b.errors,
    }));
  }

  return { isValid, allErrors };
};
export default jbValidateBidders;
